import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BarcodeGeneratorComponent } from './components/barcode-generator/barcode-generator.component';
import { BarcodeTesterComponent } from './components/barcode-tester/barcode-tester.component';
import { ImageGeneratorComponent } from './components/image-generator/image-generator.component';
import { LatestOrdersComponent } from './components/latest-orders/latest-orders.component';
import { StoreAdminPanelComponent } from './components/panel/admin-panel.component';
import { PosterOrdersComponent } from './components/panel/poster-orders/poster-orders.component';
import { PosterComponent } from './components/panel/posters/poster.component';
import { PostersComponent } from './components/panel/posters/posters.component';
import { StoreSettingsComponent } from './components/panel/store-settings/store-settings.component';
import { PrintFilesComponent } from './components/print-files/print-files.component';
import { StoreComponent } from './components/store/store.component';
import { AdminPanelComponent } from './components/admin/admin-panel.component';
import { AdminSettingsComponent } from './components/admin/settings/admin-settings.component';
import { StoresComponent } from './components/admin/stores/stores.component';
import { PictufyOverviewComponent } from './components/admin/pictufy/pictufy-overview.component';
import { DashboardComponent } from './components/admin/dashboard/dashboard.component';
import { PrintFileComponent } from './components/print-files/print-file.component';
import { CreditTransactionsComponent } from './components/panel/credit-transactions/credit-transactions.component';
import { AdminNotificationsComponent } from './components/admin/notifications/admin-notifications.component';
import { AllPosterOrdersComponent } from './components/admin/poster-orders/all-poster-orders.component';
import { CreateOrderComponent } from './components/panel/create-order/create-order.component';
import { LoginComponent } from './components/login/login.component';
import { ApiDocumentationComponent } from './components/api-documentation/api-documentation.component';
import { HelpComponent } from './components/panel/help/help.component';
import { PosterOrderComponent } from './components/panel/poster-orders/poster-order/poster-order.component';
import { StoreHomeComponent } from './components/panel/home/home.component';
import { AllReclaimsComponent } from './components/admin/reclaims/all-reclaims.component';
import { AdminOverviewComponent } from './components/admin/overview/admin-overview.component';
import { ProductOverviewComponent } from './components/panel/product-overview/product-overview.component';
import { PriceListComponent } from './components/panel/price-list/price-list.component';
import { AdminUsersComponent } from './components/admin/users/admin-users.component';
import { GenerateArtworksComponent } from './components/panel/generate-artworks/generate-artworks.component';

const routes: Routes = [
  { path: 'stores/by-access-code/:accessCode', component: StoreComponent },
  {
    path: 'stores/:storeName/:accessCode/panel', component: StoreAdminPanelComponent,
    children: [
      { path: 'orders', component: LatestOrdersComponent },
      { path: 'barcode-generator', component: BarcodeGeneratorComponent },
      { path: 'barcode-tester', component: BarcodeTesterComponent },
      { path: 'print-files/:id', component: PrintFileComponent },
      { path: 'print-files', component: PrintFilesComponent },
      { path: 'image-generator', component: ImageGeneratorComponent },
      { path: 'posters/:id', component: PosterComponent },
      { path: 'posters', component: PostersComponent },
      { path: 'poster-orders', component: PosterOrdersComponent },
      { path: 'credit-transactions', component: CreditTransactionsComponent },
      { path: 'store-settings', component: StoreSettingsComponent },
      { path: 'create-order', component: CreateOrderComponent },
      { path: 'reclaim-order/:originalOrderId', component: CreateOrderComponent },
    ]
  },
  {
    path: 'store/:storeId', component: StoreComponent,
    children: [
      { path: '', component: StoreHomeComponent },
      { path: 'orders', component: PosterOrdersComponent },
      { path: 'barcode-generator', component: BarcodeGeneratorComponent },
      { path: 'barcode-tester', component: BarcodeTesterComponent },
      { path: 'print-files/:id', component: PrintFileComponent },
      { path: 'print-files', component: PrintFilesComponent },
      { path: 'image-generator', component: ImageGeneratorComponent },
      { path: 'posters/:id', component: PosterComponent },
      { path: 'posters', component: PostersComponent },
      { path: 'poster-orders/:id', component: PosterOrderComponent },
      { path: 'poster-orders', component: PosterOrdersComponent },
      { path: 'credit-transactions', component: CreditTransactionsComponent },
      { path: 'store-settings', component: StoreSettingsComponent },
      { path: 'create-order', component: CreateOrderComponent },
      { path: 'reclaim-order/:originalOrderId', component: CreateOrderComponent },
      { path: 'help', component: HelpComponent },
      { path: 'price-list', component: PriceListComponent },
      { path: 'product-overview', component: ProductOverviewComponent },
      { path: 'generate-artworks', component: GenerateArtworksComponent },
    ]
  },
  {
    path: 'panel', component: AdminPanelComponent,
    children: [
      { path: '', component: StoresComponent },
      { path: 'overview', component: AdminOverviewComponent },
      { path: 'stores', component: StoresComponent },
      { path: 'reclaims', component: AllReclaimsComponent },
      { path: 'poster-orders', component: AllPosterOrdersComponent },
      { path: 'settings', component: AdminSettingsComponent },
      { path: 'users', component: AdminUsersComponent },
      { path: 'pictufy', component: PictufyOverviewComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'notifications', component: AdminNotificationsComponent },
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'api-documentation', component: ApiDocumentationComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
